import React from "react";
import Login from "../login/Login";
import AppliedRoute from "../AppliedRoute";


console.log('Landing Page!');
export default () =>(
    <h1>YOYOYOOY</h1>
    // <AppliedRoute path="/login" exact component={Login} props={childProps} />
);
